/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { Bizo, autoclass } from './base'
import type { EngrainMap as EngrainMapType, RawEngrainMap } from './engrain_map.types'

const DEFINITION = {
  assetId: 'assetId',
  buildingId: 'buildingId',
  floors: 'floors',
  mapId: 'mapId',
  units: 'units',
} as const

export const EngrainMap = autoclass<EngrainMapType, RawEngrainMap>(
  'EngrainMap',
  class EngrainMap extends Bizo<EngrainMapType, RawEngrainMap> {},
  DEFINITION,
  null
)
export type EngrainMap = EngrainMapType
